module.exports = __webpack_public_path__ + "static/img/01-serveCustomers.5a9e4fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/01-serveCustomers.jpg
// module id = Py3U
// module chunks = 1